import { MenuService } from './../../services/menu.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { NotificationService } from './../../services/notification.service';
import { Component, OnInit } from '@angular/core';
import { ConfirmModalService } from '../shared/confirm-modal/confirm-modal.service';



@Component({
  selector: 'app-tutoring',
  templateUrl: './tutoring.component.html',
  styleUrls: ['./tutoring.component.scss']
})
export class TutoringComponent implements OnInit {
  dataUrl: string;
  currentPageId: number;
  constructor(
    private notificationService: NotificationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private _menuService: MenuService,
    private confirmModalService: ConfirmModalService
  ) { }

  ngOnInit() {
    this.getTutoringData();
    this.extendSession();
    this.getPageData();
  }

  extendSession() {
    this._commonRequestResponseService.postWithHeader('shared/session/extend', {})
      .subscribe(
        (res: any) => {
          // ???
        },
        (error) => {
          // ???
        });
  }
  getPageData() {
    this.currentPageId = this._menuService.getCurrentPageId();
  }
  getTutoringData() {
    this._commonRequestResponseService.post('shared/thinkstorm', {})
      .subscribe(
        (data: any) => {
          if (data.url) {
            window.open(data.url);
          } else {
            this.confirmModalService.open({
              ok: () => {
              },
              text: 'Your tutoring has expired<p>Want to add more? Contact Financial Services</p>',
              labels: ['Ok']
            });
          }
        }, () => {
          this.notificationService.show('error', 'Error while getting tutoring data');
        });
  }
}
